import { Breadcrumb, Button, Dropdown, Image, Layout, Menu, MenuProps, message, theme } from 'antd';
import { DownOutline, SetOutline } from 'antd-mobile-icons';
import Footer from 'components/skeleton/footer';
import { createContext, useContext, useEffect, useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import './App.css';
// import { useState } from "react";
import { Space } from 'antd-mobile';
import { ConfigProvider } from 'antd';
import img from 'app/img';
import RoundImg from 'components/dot/img/round-img';
import Logo from 'components/dot/logo';

import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons';
import { BreadcrumbItemType } from 'antd/es/breadcrumb/Breadcrumb';
import MenuApi, { MenuDataType } from 'services/apis/sys/menu-api';
import { getItemWithExpiration, setItemWithExpiration } from 'utils/localStorageUtil';
import UserApi, { UserDataType, UserPolyInfoDT } from '../src/services/apis/sys/user-api';
import Login2 from 'pages/console/login2';
import { useWindowSize } from 'usehooks-ts';
import { Rooter } from 'pages/console/rooter';
import { MacScrollbar } from 'mac-scrollbar';
import { getBrowserFinger } from 'utils/browserFingerUtil';
import { ApiCachedSecondsRandom } from 'app/constant';
import { useDispatch, useSelector } from 'react-redux';
import { WindowSizeDT, setSize } from 'stores/windowSizeSlice';
import { useThrottledHandler } from 'App';

const { Header, Content, Sider } = Layout;

export type MenuTree = MenuDataType & {
  subMenu: MenuTree[];
};

export const CrumbContext = createContext<{
  crumbItems: any[];
  setCrumbItems: any;
}>({
  crumbItems: [],
  setCrumbItems: undefined,
});

export default function App2() {
  const [admin, setAdmin] = useState<UserPolyInfoDT>(getItemWithExpiration('adminPolyInfo'));
  const navigate = useNavigate();

  const {
    token: { colorBgContainer, colorBgSpotlight },
  } = theme.useToken();

  const [menuTree, setMenuTree] = useState<MenuProps['items']>([]);

  const userOptItems: MenuProps['items'] = [
    {
      type: 'group',
      label: '主题设置',
      children: [
        {
          label: '白天模式',
          key: 'setting:1',
        },
        {
          label: '黑夜模式',
          key: 'setting:2',
        },
      ],
    },
    {
      type: 'group',
      label: '用户设置',
      children: [
        {
          label: '修改信息',
          key: 'setting:3',
        },
        {
          label: '退出登录',
          key: 'setting:4',
        },
      ],
    },
  ];

  const _crumbItems: BreadcrumbItemType[] = [
    {
      key: 'a',
      title: '首页',
      href: '/console',
    },
    {
      key: 'b',
      title: '数据看板',
      href: '/console/board',
    },
  ];

  const [crumbItems, setCrumbItems] = useState<BreadcrumbItemType[]>(_crumbItems);

  const crumb = useContext(CrumbContext);

  // 菜单树形
  useEffect(() => {
    const menuItems: MenuProps['items'] = Rooter;
    setMenuTree(menuItems);
    // const fectchData = async () => {
    //   const result = await MenuApi.tree("0");
    //   if (result.code === 0 && result.successful) {
    //     const menuItems: MenuProps["items"] = Rooter;
    //     setMenuTree(menuItems);
    //   } else {
    //     message.error("菜单树形信息获取失败: " + result.msg);
    //   }
    // };
    // fectchData();
  }, []);

  const [collapsed, setCollapsed] = useState(false);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(setSize({ width: window.innerWidth, height: window.innerHeight }));
    console.log('browserInfo', window.innerWidth, window.innerHeight);
  }, []);
  const browserInfo: WindowSizeDT = useSelector((state: any) => state.browserHandle.info);
  // const { width, height } = useWindowSize();
  const width = browserInfo.width;
  const height = browserInfo.height;

  // 请求用户数据
  useEffect(() => {
    // 获取浏览器指纹
    getBrowserFinger().then((data) => {
      // console.log("getBrowserFinger", data);
      // 请求用户
      UserApi.getByBrowserFinger(data).then((userResult) => {
        if (userResult.successful) {
          // console.log("getByBrowserFinger", userResult.result);
          const _userPolyInfo = userResult.result as UserPolyInfoDT;
          // 设置登录用户
          setItemWithExpiration('adminPolyInfo', _userPolyInfo, ApiCachedSecondsRandom);
          setAdmin(_userPolyInfo);
          console.log('adminPolyInfo', getItemWithExpiration('userPolyInfo'));
          // // 请求用户详情
          // fetchUser(userResult.result.uuid);
        } else {
          navigate('/console');
        }
      });
    });
  }, []);

  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: '#f99',
        },
      }}
    >
      <div
        className="App2"
        style={{ background: '#f5f5f5' }}
      >
        <Layout>
          <Header
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              position: 'sticky',
              top: 0,
              zIndex: 100,
              width: '100%',
              height: 60,
              padding: '0 20px 0 20px',
            }}
          >
            <Space
              justify="center"
              align="center"
            >
              <Logo />
              <div style={{ width: 20 }} />
              <span
                style={{ color: '#fff', fontWeight: 'bolder' }}
                onClick={useThrottledHandler(() => {
                  navigate('/console');
                })}
              >
                UU天堂-后台管理系统
              </span>
            </Space>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <RoundImg
                src={img.avatar}
                width={35}
              />
              <Dropdown
                menu={{ items: userOptItems }}
                placement="bottom"
              >
                <div className=" flex justify-between items-center gap-2">
                  <span
                    style={{
                      color: '#fff',
                      marginLeft: 15,
                      width: 80,
                      display: 'inline-block',
                    }}
                  >
                    {admin == null ? '未登录' : admin.asUser.username}
                  </span>
                  <DownOutline color="white" />
                </div>
              </Dropdown>
            </div>
          </Header>
          <Layout
            className={[''].join(' ')}
            style={{
              backgroundColor: '#333',
              backgroundImage: 'url(' + img.sesamaTop2 + ')',
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'center',
              backgroundSize: 'cover',
            }}
          >
            {admin != null ? (
              <CrumbContext.Provider value={{ crumbItems, setCrumbItems }}>
                <Layout>
                  <Sider
                    trigger={null}
                    collapsible
                    width={200}
                    collapsed={collapsed}
                    style={{
                      background: colorBgContainer,
                      height: height - 60,
                      overflowY: 'auto',
                    }}
                  >
                    <MacScrollbar>
                      <Button
                        type="text"
                        icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
                        onClick={() => setCollapsed(!collapsed)}
                        style={{
                          fontSize: '16px',
                          width: '100%',
                          height: 64,
                        }}
                      />
                      <Menu
                        mode="inline"
                        defaultSelectedKeys={['board']}
                        defaultOpenKeys={['cnt']}
                        items={menuTree}
                        onClick={({ keyPath }) => {
                          //TODO:设置跳转路径
                          if (keyPath.length === 1) {
                            navigate(keyPath[0]);
                          } else {
                            const fPath = keyPath[1];
                            const cPath = keyPath[0];
                            navigate(fPath + '/' + cPath);
                          }
                        }}
                      />
                    </MacScrollbar>
                  </Sider>
                  <Layout>
                    <Layout style={{ margin: '0px 20px 0 20px' }}>
                      <Breadcrumb
                        items={crumbItems}
                        style={{ margin: '20px 0 20px 0' }}
                      />
                      <Content
                        style={{
                          padding: 20,
                          margin: 0,
                          minHeight: 280,
                          background: colorBgContainer,
                          borderRadius: 25,
                        }}
                      >
                        <Outlet />
                      </Content>
                      <Footer />
                    </Layout>
                  </Layout>
                </Layout>
              </CrumbContext.Provider>
            ) : (
              <Layout
                style={{
                  height: height - 60,
                  display: 'flex',
                  justifyContent: 'right',
                  alignItems: 'center',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  <Image
                    src={img.avatar}
                    width={'40%'}
                    height={'40%'}
                    style={{ margin: 30 }}
                    preview={false}
                  />
                  <div style={{ marginLeft: 100 }}>
                    <Login2 setUser={setAdmin} />
                  </div>
                </div>
              </Layout>
            )}
          </Layout>
        </Layout>
      </div>
    </ConfigProvider>
  );
}
